import { EmptyRow } from './types';

export const EMPTY_ORDERBOOK_ROW = 'EMPTY_ROW' as EmptyRow;
